import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        try {
            const response = await axios.get("/auth/refresh", {
                withCredentials: true,
            });
            setAuth((prev) => {
                // console.log(JSON.stringify(prev));
                // console.log(response.data.accessToken);
                // console.log("useRefreshToken", response.data);
                return {
                    ...prev,
                    accessToken: response.data.accessToken,
                    username: response.data.username,
                };
            });
            return response.data.accessToken;
        } catch (error) {
            console.log(error.message);
        }
    };
    return refresh;
};

export default useRefreshToken;
